import { Controller } from "@hotwired/stimulus"

// The import page's drop zone (#3450). The zone is the file input's label,
// so a click opens the picker; a drop or a pick submits at once, since the
// format is detected and the file counted on the server.
export default class extends Controller {
  static targets = ["input", "zone"]
  static classes = ["over", "reading"]

  over(event) {
    // Without this the browser handles the drop itself and opens the file.
    event.preventDefault()
    this.zoneTarget.classList.add(this.overClass)
  }

  leave() {
    this.zoneTarget.classList.remove(this.overClass)
  }

  drop(event) {
    event.preventDefault()
    this.leave()
    const files = event.dataTransfer?.files
    if (!files?.length) return

    this.inputTarget.files = files
    this.#submit()
  }

  pick() {
    if (this.inputTarget.files?.length) this.#submit()
  }

  // Bound to turbo:before-cache on the document and to turbo:submit-end on
  // the form: the reading state is set before the submit, so the snapshot
  // Turbo takes on the way out would keep it, and Back would restore a zone
  // that ignores clicks and still says it is reading.
  reset() {
    this.zoneTarget.classList.remove(this.overClass, this.readingClass)
  }

  submitEnd(event) {
    if (!event.detail.success) this.reset()
  }

  #submit() {
    this.zoneTarget.classList.add(this.readingClass)
    this.element.requestSubmit()
  }
}
